"use client";

import { SOCIAL_LINKS } from "@/lib/social-links";

/**
 * Icon-only links to the company's social profiles. Styled by `.social-links`
 * in marketing.css; `on-dark` is for footers on a fixed dark brand background
 * (Hillel), where the theme's text colors do not apply.
 */
export default function SocialLinks({
  className,
  variant = "default",
}: {
  className?: string;
  variant?: "default" | "on-dark";
}) {
  const classes = ["social-links", variant === "on-dark" ? "social-links--on-dark" : null, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      {SOCIAL_LINKS.map((s) => (
        <a
          key={s.name}
          className="social-links__link"
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.name}
        >
          <svg viewBox={s.viewBox} aria-hidden="true" focusable="false">
            <path d={s.path} fill="currentColor" fillRule="evenodd" />
          </svg>
        </a>
      ))}
    </div>
  );
}
